$(function () {
    if (!isListApplicationSelected()) {
        showEditMarketingTypePopup();
        $('#SelectMarketingTypeDialog').closest('.ui-dialog').find('.ui-dialog-titlebar-close').click(function () {
            saveDefaultMarketingType();
        });
    }

    $('#SanPurchaseSubscriptionHelpDialog').closest('.ui-dialog').on("dialogopen", function (event, ui) {
        // Put the "Select Marketing Type" dialog behind the overlay when the SAN instructions go up
        $('#SelectMarketingTypeDialog').closest('.ui-dialog').css('z-index', '98'); // Overlay is 99
        // Hide one of the overlays otherwise it's going to be really dark
        $('.ui-widget-overlay').each(function (index, item) {
            if (index == 0)
                $(item).removeClass('ui-widget-overlay').addClass('ui-widget-overlay-hidden');
        });
    });

    $('#SanPurchaseSubscriptionHelpDialog').closest('.ui-dialog').on("dialogclose", function (event, ui) {
        // Put the "Select Marketing Type" dialog back in front of the overlay when the SAN instructions disappear
        $('#SelectMarketingTypeDialog').closest('.ui-dialog').css('z-index', '100');
        // Show the overlay that we hid
        $('.ui-widget-overlay-hidden').each(function (index, item) {
            if (index == 0)
                $(item).removeClass('ui-widget-overlay-hidden').addClass('ui-widget-overlay');
        });
    });

    initializeSaveSearch();

    $('.marketing-type-save').click(function() {
        $(this).closest('.DotComPopup').dialog('close');
    });

    $('.SelectedMarketingDialogCancel').click(function () {
        saveDefaultMarketingType();
    });

    if ($('.selected-criteria-section :first-child').hasClass('SelectedCriteriaSection')) {
        if ($('#CurrentFlow').val() == 'CanadaBusiness') {
            $('#Geography h1').css('border-top', '0px');
        }
        else {
            $('#TypeOfBusiness h1').css('border-top', '0px');
        }
    }
});

var initializeSaveSearch = function() {
    $('.authenticate-save-search').click(function() {
        $.cookie('ShowSaveSearchPopup', true);
    });

    autoOpenSaveSearchPopup();
}

var autoOpenSaveSearchPopup = function() {
    var showSave = $.cookie('ShowSaveSearchPopup');
    if (showSave && showSave === 'true') {
        $('.SaveSearchButton').click();
        $.cookie('ShowSaveSearchPopup', false);
    }
}

var saveDefaultMarketingType = function () {

    if (typeof _CurrentSelectedCriteriaLayout != 'undefined') {
        if (_CurrentSelectedCriteriaLayout != 'ConsumerMvc' && _CurrentSelectedCriteriaLayout != 'CanadianConsumer')
            return;
    }

    if (!isListApplicationSelected()) {
        $('#SelectMarketingTypeDialog input:radio:last').prop('checked', true);
        jQuery.DotComAjax({
            url: "/Ajax/UpdateDefaultListApplication",
            cache: false,
            async: false,
            success: function (data) {
                SelectMarketingTypeSuccess();
            }
        });
    }
}

var showEditMarketingTypePopup = function () {
    $('.SelectMarketingType').click();
};

var isListApplicationSelected = function () {
    var result = false;

    if (typeof _CurrentSelectedCriteriaLayout != 'undefined') {
        if (_CurrentSelectedCriteriaLayout != 'ConsumerMvc' && _CurrentSelectedCriteriaLayout != 'CanadianConsumer')
            return true;
    }

    jQuery.DotComAjax({
        url: "/Ajax/IsListApplicationSelected",
        cache: false,
        async: false,
        success: function (data) {
            result = data.IsSelected;
        }
    });
    return result;
};



